import * as types from '../constants/actionTypes';
import techConfig from '../config';

const initialState = {
  loading: false,
  data: null,
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_LANGUAGES:
      return { ...state, loading: true };

    case types.LOAD_LANGUAGES_SUCCESS:
      if (action.payload === types.NO_RECORD_FOUND) {
        return {
          ...state,
          loading: false,
          data: [{ LanguageCode: techConfig.defaultLocale, Language: techConfig.defaultLanguage }],
          error: false,
        };
      }

      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload,
      };

    case types.LOAD_LANGUAGES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
